import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/utils/storage'
import $ from 'n-zepto'
import {config} from '@/config/index'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    // 登录用户的信息
    info: storage.getParse('info'),
    // jwt 令牌
    token: storage.get('token')
  },
  mutations: {
    // 保存用户信息  保存用户token 更新用户的路由
    login: function (state, re) {
      if (re.data) {
        storage.set('menus', re.data.menus) // 存侧边栏菜单
        storage.set('router', re.data.router) // 路由信息
        storage.set('info', re.data.info) // 存用户信息
        storage.set('token', re.data.token) // 存token
        state.info = re.data.info
        state.token = re.data.token
        // router.replace('/')
        location.replace('/')
      } else {
        this.$message.error('操作异常')
      }
    }
  },
  getters: {
    // aliOss: (state) => () => {
    aliOss: () => () => {
      let aliOss = storage.getParse('aliOss')
      if (!aliOss || (Date.parse(new Date()) / 1000 + 60 > aliOss.expiration)) {
        $.ajax({
          type: 'GET',
          url: config.baseURL + config.oss_server,
          dataType: 'json',
          async: false, // 默认异步请求
          success: function (res) {
            storage.set('aliOss', res.data)
          }
        })
      }
      return storage.getParse('aliOss')
    }
  }
})
